// window.onload=()=>{
  console.log("developer js")
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function get_attribution_json() {
    let  attribution_json= {}
    let urlString = window.location.search ;
    let queryString = new URLSearchParams(urlString);
    for(let pair of queryString.entries()) {
        attribution_json = {
            ...attribution_json, 
            [pair[0]] : pair[1]
        }
    }
    return attribution_json;
  }

// setCookie("SMSAppAutomatedId" , "" , 0)
// setCookie("SMSAppSubscriberId" , "" , 0)
// setCookie("SMSAppCampaignId" , "" , 0)

  console.log("params =>", get_attribution_json());
  let param_json = get_attribution_json();

  if('SMSAppAutomatedId' in param_json){
    setCookie("SMSAppAutomatedId" , param_json.SMSAppAutomatedId , 1 )
  }

  if('SMSAppSubscriberId' in param_json){
     setCookie("SMSAppSubscriberId" , param_json.SMSAppSubscriberId , 1 )
  }

  if('SMSAppCampaignId' in param_json){
     setCookie("SMSAppCampaignId" , param_json.SMSAppCampaignId , 1 )
  }

  let body_data = {
    attributes : {}
  }
  
  if(getCookie('SMSAppAutomatedId'))
  {
    SMSAppAutomatedId = getCookie('SMSAppAutomatedId');
    body_data = {
      ...body_data ,
      attributes : {
        ...body_data.attributes,
        SMSAppAutomatedId : SMSAppAutomatedId
      }
    }
  }

  if(getCookie('SMSAppSubscriberId'))
  {
    SMSAppSubscriberId = getCookie('SMSAppSubscriberId');
     body_data = {
      ...body_data ,
      attributes : {
        ...body_data.attributes,
        SMSAppSubscriberId : SMSAppSubscriberId
      }
    }
  }

  if(getCookie('SMSAppCampaignId'))
  {
    SMSAppCampaignId = getCookie('SMSAppCampaignId');
     body_data = {
      ...body_data ,
      attributes : {
        ...body_data.attributes,
        SMSAppCampaignId : SMSAppCampaignId
      }
    }
  }

  console.log("====================================================================================================================================");
  console.log("body_data : ", body_data);

  console.log("====================================================================================================================================");

// Check cart is empty or has any product
$.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(cart) {
    if (cart.item_count > 0) {
      console.log('The cart is not empty');

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body:JSON.stringify(body_data)
      })
      
    } else {
      console.log('The cart is empty');
    }
  }
});
  
// }




// Check if order is placed then delete our cookie
// var $ = Checkout.$
//       $(document).on("page:load page:change", function() {
//         if(window.Shopify && Shopify.Checkout && Shopify.Checkout.step === 'thank_you') 
//         {
//             setCookie("SMSAppAutomatedId" , "" , 0)
//             setCookie("SMSAppSubscriberId" , "" , 0)
//             setCookie("SMSAppCampaignId" , "" , 0)
//         }
//       });